module.exports = __webpack_public_path__ + "img/Logo-light.9ff41aa0.png";